import { Component, OnInit } from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { Router, ActivatedRoute } from '@angular/router';
import { SitesettingsService } from '../../services/sitesettings.service';
import { environment } from './../../../environments/environment';
import { AuthenticationService } from '../../services/authentication.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

const API_URL = environment.API_URL;
const ASSET_URL = environment.DO_ENDPOINT;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    site_title: String;
    sitelogo: String;
    user: any;
    constructor(private router: Router,
        private route: ActivatedRoute, private service: SitesettingsService, private translate: TranslateService,
        private authService: AuthenticationService) {
    }

ngOnInit() {
  $.getScript('./assets/js/app-sidebar.js');

  // Get user either from service or localStorage
  const localUser = localStorage.getItem('user');
  this.user = this.authService.userdata || (localUser ? JSON.parse(localUser) : null);

  if (this.user) {
    if (this.user.role === 'super_admin') {
      // Super admin sees everything
      this.menuItems = ROUTES.filter(menuItem => menuItem);
    } else if (Array.isArray(this.user.menu)) {
      // Restrict based on allowed menu titles
      this.menuItems = ROUTES.filter(menuItem =>
        this.user.menu.includes(menuItem.title) ||
        (menuItem.title === "GFire" && this.user.menu.includes("G Fire Alert"))
      );
    } else {
      this.menuItems = []; // no menu access
    }
  } else {
    this.menuItems = []; // not logged in
  }

  this.getsitedata();
}

    getsitedata() {
        this.service.getsitedatasettings().subscribe(res => {
            this.site_title = res.result.site_title;
            // this.sitelogo = API_URL + '/assets/public/logos/' + res.result.logo;
            this.sitelogo = ASSET_URL + "/logos/" + res.result.logo;
          });
    }

    /* NGX Wizard - skip url change */
    ngxWizardFunction(path: string) {
        if (path.indexOf('forms/ngx') !== -1) {
            this.router.navigate(['forms/ngx/wizard'], { skipLocationChange: false });
        }
    }

    onLogout() {
        if (confirm('Are you sure you want to log out?')) {
            this.authService.logout();
            this.router.navigate(['/admin']);
            return false;
        }
    }
}
